var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-height" },
    [
      _c("img", _vm._b({ attrs: { src: _vm.src } }, "img", _vm.$attrs, false)),
      _c(
        "q-inner-loading",
        { attrs: { visible: !_vm.loaded, dark: "" } },
        [_c("q-spinner")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }